import { loadElasticSearchResults } from '@modules/product-tagging/api/load-elastic-search-results.server';
import type { LoaderFunctionArgs } from '@remix-run/node';
import type { ElasticSearchQueryFilters } from '@modules/search';

export const ProductTaggingProductSearch =
    '/remix-api/product-tagging/product-search';

export const loader = async (args: LoaderFunctionArgs) => {
    let filterBy: ElasticSearchQueryFilters = {};

    return await loadElasticSearchResults({
        args,
        searchType: 'product',
        filterBy,
    });
};
